import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import useValidation from "app/common/custom-hooks/useValidation";
import SpinnerButton from "app/common/components/SpinnerButton";
import FormInput from "app/common/components/FormInput";
import ResponsiveCol from "app/common/components/ResponsiveCol";
import { debounce } from "app/common/util/Helpers";
import toastMessage from "app/common/util/toastMessage";
import useActionListener from "app/common/custom-hooks/useActionListener";
import { resetPassword } from "app/redux/auth/authHandler";
import { useNavigate } from "react-router-dom";

const Step3 = ({email, otp, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {validation, setValidation, markAsValidated, data} = useValidation(formRef);

    // Password fields compare
    const handleConfirmChange = debounce(_ => {
        const newpassword = formRef.current?.querySelector('input[name="newpassword"]').value;
        const confirmPassword = formRef.current?.querySelector('input[name="confirmPassword"]').value;
        const passEqual = (newpassword === confirmPassword);
        setValidation(val => ({...val, allValid: passEqual ? val.allValid : false, fields: {...val.fields, confirmPassword: passEqual}}));
    }, 50);

    // Form Submission process
    const handleSubmit = _ => {
        if (data.newpassword === data.confirmPassword){
            dispatch(resetPassword({...data, email, otp}));
        }
        else {
            toastMessage("error", "Confirm password not match")
        }
    }

    useActionListener("passwordReset", _ => {
        navigate("/login");
    })

    return  <div className="-mt-10">
                <form onSubmit={handleSubmit} ref={formRef} onInput={handleConfirmChange}>
                    <h2
                        className="text-3xl md:text-[2.5rem] md:leading-[3rem] text-black-1 font-semibold pb-2 dark:text-white "
                    >
                        Secure your <br/> account
                    </h2>
                    <p
                        className="pb-12 text-grey-7"
                    >
                        Set up a new password for your account
                    </p>
                    <ResponsiveCol className="">
                        <FormInput
                            label="New password"
                            type='password'  
                            name="newpassword"
                            placeholder="Create a new password"
                            validation={validation}
                            invalidMessage="Enter valid password (Minimum of Eight Characters, One Uppercase, One Lowercase, One Number and One Symbol)"
                            colclass="sm:w-full"
                            onFocus={_ => validation.validated ? null : markAsValidated()}
                            required
                        />
                        <FormInput
                            label="Confirm password"
                            type='password'  
                            name="confirmPassword"
                            placeholder="Re-enter password"
                            validation={validation}
                            invalidMessage="Confirm password not match"
                            colclass="sm:w-full"
                            required
                        />
                        <SpinnerButton 
                                type="submit"  
                                colclass="sm:w-full"
                                disabled={!validation.allValid} 
                                className="w-full btn-primary btn-md" 
                                isLoading={isLoading}
                                text="Set new password"
                            />
                        
                    </ResponsiveCol>
                    
                </form>
            </div>
}

export default Step3;